var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Card, Skeleton, SkeletonBlock, SkeletonLine, } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect, useState } from 'react';
import { PHCard } from './PHCard';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import AlertBanner from '../../shared/AlertBanner';
import { PHPagination } from '../PHPagination';
import NoOrdersView from '../NoOrdersView';
var cardSkeleton = function (key) { return (React.createElement("div", { key: key, className: "sui-mb-6" },
    React.createElement(Card, { grow: true },
        React.createElement("div", { className: "sui-flex sui-min-w-full sui-gap-10" },
            React.createElement("div", { className: "sui-w-5/12 sui-flex sui-flex-col sui-gap-4" },
                React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }),
                React.createElement(SkeletonLine, { numberOfLines: 3 }),
                React.createElement(Skeleton, { disablePadding: true, orientation: "horizontal" }, __spreadArray([], Array(4), true).map(function (__f, jkey) { return (React.createElement("div", { key: jkey },
                    React.createElement(SkeletonBlock, { height: 12, width: 12 }))); }))),
            React.createElement("div", { className: "sui-w-7/12 sui-flex sui-flex-col sui-gap-4" },
                React.createElement("div", { className: "sui-ml-auto sui-mb-auto" },
                    React.createElement(SkeletonBlock, { height: 8, width: 8 })),
                React.createElement(SkeletonLine, { numberOfLines: 3 }),
                React.createElement(SkeletonLine, { variant: "heading", fullWidth: true })))))); };
var PHCardViewSkeleton = function () {
    return (React.createElement(React.Fragment, null, __spreadArray([], Array(3), true).map(function (_e, index) {
        return cardSkeleton("ph-card-skeleton-".concat(index));
    })));
};
export var PHCardView = function (_a) {
    var _b, _c;
    var customerRole = _a.customerRole, customerType = _a.customerType;
    var _d = usePurchaseHistoryContext(), orderHistoryData = _d.orderHistoryData, orderHistoryLoaded = _d.orderHistoryLoaded, orderHistoryError = _d.orderHistoryError, alertState = _d.alertState, setAlertState = _d.setAlertState, setOpenAddReceiptDrawer = _d.setOpenAddReceiptDrawer;
    var _f = useState(false), renderBuffer = _f[0], setRenderBuffer = _f[1];
    var records = (_b = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) !== null && _b !== void 0 ? _b : orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.lineItems;
    var totalNumberOfOrders = (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.itemsCount) || 0;
    setTimeout(function () {
        setRenderBuffer(true);
    }, 500);
    useEffect(function () {
        var _a;
        if (((_a = orderHistoryError === null || orderHistoryError === void 0 ? void 0 : orderHistoryError.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
            setAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: "We're sorry, there is a technical error. Please try again later.",
                status: 'error',
            });
            return;
        }
        if (orderHistoryError) {
            setAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: 'Something went wrong on our end. Please check back later',
                status: 'error',
            });
        }
    }, [orderHistoryError]);
    var phCardAlertElement = function () {
        if (alertState) {
            return (React.createElement("div", { className: "sui-col-span-1" }, alertState && React.createElement(AlertBanner, __assign({}, alertState))));
        }
        return null;
    };
    if (orderHistoryLoaded &&
        (totalNumberOfOrders === 0 || ((_c = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _c === void 0 ? void 0 : _c.length) === 0)) {
        return (React.createElement(ErrorBoundary, { name: "no-orders" },
            React.createElement(NoOrdersView, { customerType: customerType, setOpenAddReceiptModal: setOpenAddReceiptDrawer })));
    }
    if (orderHistoryLoaded) {
        return (React.createElement("div", null,
            phCardAlertElement(), records === null || records === void 0 ? void 0 :
            records.map(function (record, index) { return (React.createElement(PHCard, { key: index, customerRole: customerRole, customerType: customerType, record: record, index: index })); }),
            React.createElement(ErrorBoundary, { name: "pagination" },
                React.createElement(PHPagination, null))));
    }
    return renderBuffer ? React.createElement(PHCardViewSkeleton, null) : React.createElement(React.Fragment, null);
};
